import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicField, DynamicFieldType, DynamicFieldTypes, InputTypes, DynamicFormModule } from '@mt-ng2/dynamic-form';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@mt-ng2/dynamic-form';
class MtNoteComponent {
    constructor() {
        /**
         * boolean to toggle auto focus to the note title
         */
        this.focus = false;
        this.ready = new EventEmitter();
        this.readyToShow = false;
    }
    /**
     * load the form
     */
    ngOnInit() {
        this.loadForm();
        this.ready.emit({ form: this.parentForm });
    }
    ngAfterViewInit() {
        if (this.focus) {
            setTimeout(() => {
                this.parentForm.get('Title').mtFocus();
            }, 0);
        }
    }
    /**
     * build the form based on the INote Object and attach
     * the new group to the parent form
     */
    loadForm() {
        if (!this.parentForm) {
            this.parentForm = new FormGroup({});
        }
        this.parentForm.addControl('Id', new FormControl(this.note.Id));
        this.titleField = new DynamicField({
            formGroup: '',
            label: 'Title',
            name: 'Title',
            type: new DynamicFieldType({
                fieldType: DynamicFieldTypes.Input,
                inputType: InputTypes.Textbox,
            }),
            value: this.note.Title,
        });
        this.titleField.setRequired(true);
        this.noteTextField = new DynamicField({
            formGroup: '',
            label: 'Note Text',
            name: 'NoteText',
            type: new DynamicFieldType({
                fieldType: DynamicFieldTypes.Input,
                inputType: InputTypes.WYSIWYG,
            }),
            value: this.note.NoteText,
        });
        this.noteTextField.setRequired(true);
    }
}
MtNoteComponent.ɵfac = function MtNoteComponent_Factory(t) { return new (t || MtNoteComponent)(); };
MtNoteComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MtNoteComponent, selectors: [["mt-note"]], inputs: { focus: "focus", parentForm: "parentForm", note: "note" }, outputs: { ready: "ready" }, decls: 7, vars: 7, consts: [[3, "formGroup"], [3, "field", "form", "overrideForm"]], template: function MtNoteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelement(2, "dynamic-field", 1);
        ɵngcc0.ɵɵtext(3, "\n    ");
        ɵngcc0.ɵɵelement(4, "dynamic-field", 1);
        ɵngcc0.ɵɵtext(5, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(6, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.parentForm);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("field", ctx.titleField)("form", ctx.parentForm)("overrideForm", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("field", ctx.noteTextField)("form", ctx.parentForm)("overrideForm", true);
    } }, directives: [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.DynamicFieldComponent], encapsulation: 2 });
MtNoteComponent.ctorParameters = () => [];
MtNoteComponent.propDecorators = {
    note: [{ type: Input }],
    parentForm: [{ type: Input }],
    focus: [{ type: Input }],
    ready: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtNoteComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'mt-note',
                template: "<div [formGroup]=\"parentForm\">\n    <dynamic-field [field]=\"titleField\" [form]=\"parentForm\" [overrideForm]=\"true\"></dynamic-field>\n    <dynamic-field [field]=\"noteTextField\" [form]=\"parentForm\" [overrideForm]=\"true\"></dynamic-field>\n</div>\n"
            }]
    }], function () { return []; }, { focus: [{
            type: Input
        }], ready: [{
            type: Output
        }], parentForm: [{
            type: Input
        }], note: [{
            type: Input
        }] }); })();

class MtNoteControlModule {
}
MtNoteControlModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MtNoteControlModule });
MtNoteControlModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MtNoteControlModule_Factory(t) { return new (t || MtNoteControlModule)(); }, imports: [[CommonModule, FormsModule, ReactiveFormsModule, DynamicFormModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtNoteControlModule, { declarations: function () { return [MtNoteComponent]; }, imports: function () { return [CommonModule, FormsModule, ReactiveFormsModule, DynamicFormModule]; }, exports: function () { return [MtNoteComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtNoteControlModule, [{
        type: NgModule,
        args: [{
                declarations: [MtNoteComponent],
                exports: [MtNoteComponent],
                imports: [CommonModule, FormsModule, ReactiveFormsModule, DynamicFormModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MtNoteComponent, MtNoteControlModule };

//# sourceMappingURL=mt-ng2-note-control.js.map